unit UPersonalizacao_Tabela.Interfaces;

interface

uses
  System.SysUtils;

type

  IPersonalizacao_Tabela = interface
    ['{DBB07D66-BF13-4E9E-A8BD-EB18AB2BECB7}']

    procedure SalvarPersonalizacao(pJson : string);
    procedure RestaurarPersonalizacao;
  end;

implementation

end.
